<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-down-choice`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.879 33.317l-4.95 4.949-2.121-2.121a1 1 0 00-1.415 0L4.98 37.559a1 1 0 000 1.414l4.243 4.243c.15.15.336.243.53.277l.118.014h.118a.996.996 0 00.648-.29l7.071-7.072a1 1 0 000-1.414l-1.414-1.414a1 1 0 00-1.414 0zM23 37.024a1 1 0 00-1 1v2a1 1 0 001 1h20a1 1 0 001-1v-2a1 1 0 00-1-1H23zM8 22a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1H8zm15 1.024a1 1 0 00-1 1v2a1 1 0 001 1h20a1 1 0 001-1v-2a1 1 0 00-1-1H23zM8 8a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V9a1 1 0 00-1-1H8zm15 1.024a1 1 0 00-1 1v2a1 1 0 001 1h20a1 1 0 001-1v-2a1 1 0 00-1-1H23z"/></svg>
</template>
<script>

export default {
  name: 'IconDownChoice',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
